
import {INTERVIEW_PLANNED_REQUEST, INTERVIEW_PLANNED_SUCCESS,INTERVIEW_PLANNED_FAIL} from "../constants/AuthConstant"

const axios = require("axios");
export const InterviewPlannedAction = (id,pageNumber,size) => {
    return function (dispatch) {
      dispatch({
        type: INTERVIEW_PLANNED_REQUEST,
        payload: true,
      });
    
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/interview/get_interview_scheduled_by_vendorId?vendorId=${id}&pageNumber=${pageNumber}&pageSize=${size??10}&flag=true`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: INTERVIEW_PLANNED_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };

  export const loadAllDetailsPre = (data) => {
    return {
      type: INTERVIEW_PLANNED_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };